import { JsonObject, JsonProperty } from 'json2typescript';

/**
 * åªä½èµæº(å¾ç, é³é¢, è§é¢)ä¿¡æ¯
 */
@JsonObject
export class MediaInfo {
  /**
   * åªä½èµæºId
   */
  @JsonProperty('mediaId', Number)
  mediaId: number = undefined;

  /**
   * åªä½èµæºçé®å¼, ç¨äºæ ç¤ºåªä½èµæºå¨ossä¸­å­æ¾çä½ç½®
   * ä¾å­:
   * /dev/video/dept1/abc.mp4
   * /dev/other/dept2/xyz.png
   */
  @JsonProperty('mediaKey', String)
  mediaKey: string = undefined;

  /**
   * è¯¥åªä½èµæºå·ä½çurlå°å
   * ä¸è¬ç¨keyå¼ååå°æ¥è¯¢è·å¾, ä½¿ç¨é¿éäºstsæ§å¶è®¿é®æé, ä¸è¬æ2å°æ¶è¿ææ¶é´
   * ä¾å­:
   * https://media.512ks.cn/dev/other/tenant764/1331d3db3c2f96b4f949ad6cf97a9d8e.jpg?Expires=1511254053&OSSAccessKeyId=LTAIoGU8SUvxZrCy&
   * Signature=V83jY722mWnfBhX2xD8x%2Bbqxn6M%3D&x-oss-process=image%2Fformat%2Cjpg%2Fresize%2Ch_400%2Fquality%2CQ_75
   */
  @JsonProperty('url', String)
  url: string = undefined;
}
